import { isNil } from './isNil';

export class InvariantError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'Invariant Violation';
  }
}

export const isNotNilInvariantAsync = <T, U>(
  optional: T | undefined | null,
  message: string,
  fn: (arg: T) => Promise<U>,
): Promise<U> => {
  if (isNil(optional)) {
    return Promise.reject(new InvariantError(message));
  }

  return fn(optional);
};

/**
 Throws an error if the DateTime is invalid. Luxon returns null in this case.
 @deprecated
 */
export const isNotNullDateTimeInvariant = (dateTime: string | null) => {
  if (dateTime === null) {
    throw new InvariantError('Invalid DateTime');
  }
  return dateTime;
};
